
import { getJobArticles, getJobTicket } from '@/api';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import Avatar from '@/components/UI/avatar/Avatar.vue';
import Icon from '@/components/UI/Icon.vue';
import ZammadTicket from '@/components/jobDetailed/ZammadTicket.vue';
import AffiliatedJobsHeaderItem from '@/components/jobDetailed/zammadTicketPage/headerItems/AffiliatedJobsHeaderItem.vue';

import { notificationErrorText } from '@/utils/PortalConstants';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { checkTicketIsRfc } from '@/utils/Common';

import { User } from '@/models/main';
import { JobTicketAtricle, JobTicketResponce } from '@/models/jobTicket';
import { JobDetailedData } from '@/models/jobDetailed';
import { fetchSetTicketState } from '@/helpers/fetchers';

@Component({
  components: {
    Avatar,
    DateTimezoneToggle,
    Icon,
    ZammadTicket,
    AffiliatedJobsHeaderItem,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class ZammadTicketPage extends Vue {
  public loading = false;
  public loadingCloseRfc = false;
  public user: User;

  public format = format;
  public utcToZonedTime = utcToZonedTime;
  public timeZoneDefault = timeZoneDefault;

  public articlesData: JobTicketAtricle[] = [];
  public ticketData: JobTicketResponce = {
    article_count: 0,
    article_ids: [],
    close_at: '',
    close_diff_in_min: null,
    close_escalation_at: null,
    close_in_min: null,
    create_article_sender: '',
    create_article_sender_id: 0,
    create_article_type: '',
    create_article_type_id: 0,
    created_at: '',
    created_by: '',
    created_by_id: 0,
    customer: '',
    customer_id: 0,
    escalation_at: null,
    first_response_at: '',
    first_response_diff_in_min: 0,
    first_response_escalation_at: null,
    first_response_in_min: '',
    group: '',
    group_id: 0,
    id: 0,
    last_contact_agent_at: '',
    last_contact_at: '',
    last_contact_customer_at: '',
    last_owner_update_at: null,
    note: null,
    number: '',
    organization_id: null,
    owner: '',
    owner_id: 0,
    pending_time: null,
    preferences: {
      escalation_calculation: {
        calendar_id: 0,
        calendar_updated_at: '',
        escalation_disabled: false,
        first_response_at: '',
        last_contact_at: '',
        last_update_at: '',
        sla_id: 0,
        sla_updated_at: '',
      },
    },
    calendar_id: 0,
    calendar_updated_at: '',
    escalation_disabled: false,
    last_update_at: '',
    sla_id: 0,
    sla_updated_at: '',
    priority: '',
    priority_id: 0,
    rh_job: '',
    state: '',
    state_id: 0,
    ticket_time_accounting: [],
    ticket_time_accounting_ids: [],
    time_unit: null,
    title: '',
    type: null,
    update_diff_in_min: null,
    update_escalation_at: null,
    update_in_min: null,
    updated_at: '',
    updated_by: '',
    updated_by_id: 0,
    is_rfc: false,
  };

  public job: JobDetailedData;
  public checkTicketIsRfc = checkTicketIsRfc;
  public files: File[] = [];
  public editingTicketAttachments: File[] = [];

  private async loadTicketData(id: string) {
    this.loading = true;
    if (id) {
      // Get articles
      await getJobArticles(Number(id))
        .then(res => {
          this.articlesData = res;
        })
        .catch(() => {
          this.$notify({
            group: 'network',
            title: 'Error getting articles',
            text: notificationErrorText,
            type: 'warn',
          });
          this.$router.replace({ path: '/error' });
        });
      // Get ticket
      await getJobTicket(Number(id))
        .then(res => {
          this.ticketData = res;
        })
        .catch(() => {
          this.$notify({
            group: 'network',
            title: 'Error getting the ticket',
            text: notificationErrorText,
            type: 'warn',
          });
        });
    }
    this.loading = false;
  }

  public zammadListChanged(ticket) {
    this.ticketData = ticket;
  }

  public async setTicketState(state: string, state_id: number) {
    this.loadingCloseRfc = true;
    await fetchSetTicketState(this.ticketData, state, state_id).then(res => {
      this.ticketData = res;
    });
    this.loadingCloseRfc = false;
  }

  private async mounted() {
    await this.loadTicketData(this.$route.params.id);
  }

  private created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // ticket route changes:
        if (toParams.id && previousParams.id) {
          this.loadTicketData(toParams.id);
        }
      },
    );
  }
}
